import PropTypes from "prop-types";

// import { getCleanLabel } from "utils";
// import { Tooltip } from "components/Tooltip";
import { KeyStatsContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { KeyStatsModalContainer } from "./KeyStats.styles";
import { Button } from "components/Button/index";

export const KeyStatsModal = ({ show, onHide, stats, getFormattedValue }) => {
  return (
    <KeyStatsModalContainer
      className="key-stats-modal"
      headingClass="key-stats-heading"
      show={show}
      onHide={onHide}
    >
      <KeyStatsContainer>
        <div className="heading">
          <h2>Key Metrics</h2>
        </div>

        <ul className="modal-ul">
          {stats.map((data, i) => {
            // const label = getCleanLabel(data.description);

            return (
              <li key={i}>
                <div className="label-wrapper">
                  <span className="key text-ellipsis">
                    <span className="label">{data.name}</span>
                    {/* <Tooltip
                      placement="auto"
                      value={label}
                      tooltipClassName="v2-tooltip"
                    /> */}
                  </span>
                </div>
                <span className="stats">{getFormattedValue(data?.value)}</span>
              </li>
            );
          })}
        </ul>
        <div className="btn-wrapper">
          <Button onClick={onHide}>Close</Button>
        </div>
      </KeyStatsContainer>
    </KeyStatsModalContainer>
  );
};

KeyStatsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  getFormattedValue: PropTypes.func,
  stats: PropTypes.array,
};
